var React = require('react');
import * as Yup from 'yup';
import { Box, Container, Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import FormControl from '@mui/material/FormControl';
import MUIDataTable from 'mui-datatables';
import AppBar from '@mui/material/AppBar';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@mui/material/Button";
import SaveIcon from "@material-ui/icons/Save";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import TextField from "@mui/material/TextField";
import { MuiThemeProvider } from '@material-ui/core/styles';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import { muiThemeDesign } from '../../mui-theme-design';
import moment from "moment";
import { makeStyles } from "@mui/styles";
import Checkbox from '@mui/material/Checkbox';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import {logger, handleExport, customBodyForExcelReport,checkAuthentication,muiLoaderOptions} from '../../utils';

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff!important',
            fill: '#ffffff'
        },
        "& .MuiSvgIcon-root": {
            color: '#ffffff',
            fill: '#ffffff',
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },
        "& .MuiButton-root": {
            fontSize: "0.7rem"
        },
    },

}));

export default function ReportsTimeDelete() {
    const [refresh, setRefresh] = React.useState(false);
    const [dataSet, setDataSet] = React.useState([]);
    const [StartDate, setStartDate] = React.useState(moment(new Date()).startOf('month').format('YYYY-MM-DD'));
    const [EndDate, setEndDate] = React.useState(moment(new Date()).endOf('month').format('YYYY-MM-DD'));
    const [open, setOpen] = React.useState(false);
    const [openLogs, setOpenLogs] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);

    const initialValues = {
    };

    const validFormSchema = Yup.object({
    })

    const classes = pageStyles();
    const convertDates = (json) => {
		json.forEach(eachObj => {
			if (eachObj.DayOf) {
				eachObj.DayOf = moment.utc(eachObj.DayOf).format("MM/DD/YYYY");
			}
		});
		setDataSet(json);
	};

    const getData = async () => {
        await fetch(`/api/Reports/TimeDelete/${moment(StartDate).format('YYYY-MM-DD')}/${moment(EndDate).format('YYYY-MM-DD')}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => {
					convertDates(json);
					setIsLoading(false);
				})

    };

    const handleGenerate = () => {
        setOpenLogs(true);
        getData()
        setIsLoading(true);
    };

    const columns = [
        {
            name: "FirstName",
            label: "First Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "LastName",
            label: "Last Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "DayOf",
            label: "Day Of",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        dataSet[dataIndex].DayOf
                    );
                }
            }
        },
        {
            name: "task",
            label: "task",
            options: {
                filter: true,
                sort: true,
            }
        }, 
        {
            name: "Hours",
            label: "Hours",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "FlagType",
            label: "Flag Type",
            options: {
                filter: true,
                sort: true,
            }
        },
    ];

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('rowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('rowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        fixedHeader: true,
        fixedSelectColumn: false,
        tableBodyHeight: "400px",
        tableBodyMaxHeight: "1000px",
        rowsPerPage: initialRowsPerPage,
        responsive: 'standard',
        rowsPerPageOptions: [10, 20, 50, 100],
        textLabels: {
		    toolbar: {
		      search: "Search",
		      downloadCsv: "Download Excel", 
		      print: "Print",
		      viewColumns: "View Columns",
		      filterTable: "Filter Table",
		    	},
		},
        selectableRows: 'none',
        onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}

			const customBuildBody = () => {
				const headers = customBuildHead();
				logger("headers", headers);
				return customBodyForExcelReport({data:data, headers:headers});
			};

			const headers = customBuildHead();
			const rows = customBuildBody();
			handleExport({rows:rows, headers:headers, filename: 'DeletedTimeEntry.xlsx'});
			return false;
		}

    };

    const handleStartDate = (Data) => {
        setStartDate(Data.target.value);
        logger(Data.target.value);
    }

    const handleEndDate = (Data) => {
        setEndDate(Data.target.value);
        logger(Data.target.value);
    }

    const handleOpenForLogs = () => {
        setOpenLogs(true)
    };

    const handleCloseForLogs = () => {
        setDataSet([])
        setOpenLogs(false);
    };

    const handleClickOpen = () => {

        setRefresh(true)
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    React.useEffect(() => {
		checkAuthentication();
        if (refresh) {
            getData()

            setRefresh(false);
        }

    })

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        <div className={classes.root}>
            <Button variant="contained" onClick={handleClickOpen}>
                Reports Time Delete
            </Button>
            <MuiThemeProvider theme={muiThemeDesign}>
                <Dialog className={classes.root} open={open} onClose={handleClose} fullWidth maxWidth="md">
                    <DialogContent >
                        <Formik
                            initialValues={initialValues}
                            validationSchema={validFormSchema}
                            onSubmit={(values, { resetForm }) => {
                                //onTrigger(values);
                                resetForm();
                            }}
                        >
                            {props => (
                                <Form>
                                    <AppBar sx={{ position: 'relative' }}>
                                        <Toolbar>
                                            <IconButton
                                                edge="start"
                                                color="inherit"
                                                onClick={handleClose}
                                                aria-label="close"
                                            >
                                                <CloseIcon />
                                            </IconButton>
                                            <Typography sx={{ ml: 2, flex: 1, color: "white" }} variant="h6" component="div" >
                                                Reports Time Delete
                                            </Typography>
                                            <Button color="inherit" onClick={handleGenerate}>
                                                Generate
                                            </Button>
                                        </Toolbar>
                                    </AppBar>
                                    <DialogTitle>Time Entry L&P Check:</DialogTitle>
                                    <div>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <TextField
                                                name='start'
                                                id="outlined-StartDate"
                                                type="date"
                                                onChange={handleStartDate}
                                                value={StartDate}
                                                label="Start Date"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </FormControl>
                                        <FormControl sx={{ m: 1, width: 220 }}>
                                            <TextField
                                                name='end'
                                                id="outlined-EndDate"
                                                type="date"
                                                onChange={handleEndDate}
                                                value={EndDate}
                                                label="End Date"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </FormControl>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </DialogContent>
                    <Dialog className={classes.root} open={openLogs} onClose={handleCloseForLogs} fullWidth maxWidth="1400px" scroll="paper" overflow-y="hidden">
                        <DialogContent >
                            <Box>

                                <MUIDataTable className={classes.root}
                                    title={

                                        <Typography variant="h6" style={{ color: "white" }}>
                                            <IconButton edge="start" color="inherit" onClick={handleCloseForLogs} aria-label="close"> <CloseIcon /> </IconButton>
                                            Reports Time Delete
                                        </Typography>
                                    }
                                    data={isLoading ? [] : dataSet}
                                    columns={columns}
                                    options={muiLoaderOptions(options, isLoading)}
                                />
                            </Box>
                        </DialogContent>
                    </Dialog>
                </Dialog>
            </MuiThemeProvider>
        </div>
    );
}

 